const gettersPropertyTaxesDepreciations = {
	BuildingToLandPercentage(state) {
		if (
			state.result['building_value']
			&& state.result['building_value'] !== ''
			&& state.result['land_value']
			&& state.result['land_value'] !== ''
		) {
			return (100 * +state.result['building_value']) / (+state.result['building_value'] + +state.result['land_value']);
		}
		return 0;
	},
	AssessedValue(state) {
		if (
			state.result['building_value']
			&& state.result['building_value'] !== ''
			&& state.result['land_value']
			&& state.result['land_value'] !== ''
			&& state.result['assessment_percentage']
			&& state.result['assessment_percentage']
		) {
			return ((+state.result['building_value'] 	+ +state.result['land_value']) 	* +state.result['assessment_percentage']) / 100;
		}
		return 0;
	},
	AnnualPropertyTaxEstimate(state, getters) {
		if (
			getters.AssessedValue
			&& getters.AssessedValue !== 0
			&& state.result['property_tax_rate']
			&& state.result['property_tax_rate'] !== ''
		) {
			return (+getters.AssessedValue * +state.result['property_tax_rate']) / 100;
		}
		return 0;
	},
	EstimatedMonthlyPropertyTaxes(state, getters) {
		if (
			getters.AnnualPropertyTaxEstimate
			&& getters.AnnualPropertyTaxEstimate !== 0
		) {
			return +getters.AnnualPropertyTaxEstimate / 12;
		}
		return 0;
	},
	AnnualDepreciationExpense(state, getters) {
		if (
			state.result['home_price']
			&& state.result['home_price'] !== ''
			&& getters.BuildingToLandPercentage
			&& getters.BuildingToLandPercentage !== 0
			&& state.result['home_depreciation']
			&& state.result['home_depreciation'] !== ''
		) {
			return (+state.result['home_price'] * (+getters.BuildingToLandPercentage / 100)) / +state.result['home_depreciation'];
		}
		return 0;
	}
};

export {
	gettersPropertyTaxesDepreciations
};
